import { HttpClient, HttpEvent, HttpRequest, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform, LoadingController } from '@ionic/angular';
import { GeolocationService } from './geolocation.service';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    public http: HttpClient,
    public alertController: AlertController,
    public platform: Platform,
    public geolocation: GeolocationService,
    public loadingController: LoadingController
  ) { }
  public apiURLZaimu = 'https://clicsoka-sgiv.org/clicsoka/api/zaimu';

  private getRoutes = {

  };
  private postRoutes = {
    groups: this.apiURLZaimu,
    registerToTopic: 'https://us-central1-pdsgiv.cloudfunctions.net/registerToTopic',
    userCreated: 'https://us-central1-pdsgiv.cloudfunctions.net/createUser',
  };
  private putRoutes = {};
  private deleteRoutes = {};

  get(route: string = '', params = {}, id = [], other: any = {}, httpHeaders: any = {}, absolute = false) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders({
        ...httpHeaders,
      });
      params = new HttpParams({
        fromObject: params
      });
      let req: HttpRequest<any>;
      if (absolute) {
        req = new HttpRequest('GET', route, {
          headers,
          params,
          ...other,
        });
      } else {
        req = new HttpRequest('GET', id.length > 0 ? this.getRoutes[route](...id) : this.getRoutes[route], {
          headers,
          params,
          ...other
        });
      }
      this.http.request(req).subscribe({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            resolve(event.body);
          }
        }, 
        error: error => {
          reject(error);
        }
      });
    });
  }
  post(route: string = '', body = {}, id = null) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'If-Modified-Since': '0',
      });
      const req = new HttpRequest('POST', id ? this.postRoutes[route](id) : this.postRoutes[route], body, {
        headers
      });
      this.http.request(req).subscribe({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            resolve(event.body);
          }
        }, 
        error: error => {
          reject(error);
        }
      });
    });
  }
  put(route: string = '', body = {}, id = null) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'If-Modified-Since': '0',
      });
      const req = new HttpRequest('PUT', id ? this.putRoutes[route](id) : this.putRoutes[route], body, {
        headers
      });
      this.http.request(req).subscribe({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            resolve(event.body);
          }
        },
        error:  error => {
          reject(error);
        }
      });
    });
  }
  delete(route: string = '', body = {}, id = []) {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        'If-Modified-Since': '0',
      });
      const req = new HttpRequest('DELETE', id.length > 0 ? this.deleteRoutes[route](...id) : this.deleteRoutes[route], body, {
        headers
      });
      this.http.request(req).subscribe({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            resolve(event.body);
          }
        },
        error: error => {
          reject(error);
        }
      });
    });
  }
}
